import React from 'react'
import Modal from '../../common/Modal/Modal';

/**
 * Modal that opens when the user sends a message to the External Member.
 * It shows if the message was successful or not.
 */

function MessageResultModal({messageResult, onClose, isOpen}) {

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={handleCloseModal}
        title={messageResult.status === "success" ? "Message Sent" : "Message Failed"}
        showCustomContent={true}
        customContent={
            messageResult.status === "success" ? (
                // If message is sent successfully
                <>
                  <div className="modal-success-container">
                    <div className="icon-container">
                      <i className="fas fa-check" />
                    </div>
                    <div className="download-success-message">
                    The link was successfully sent to the client.
                    </div>
                  </div>
                  <div className="savemodal-btn-container">
                  <button className="button-close" onClick={handleCloseModal}>
                    Done
                  </button>
                  </div>
                </>
              ) : (
                // Message failed
                <>
                  <div className="download-failed-message">
                  There was a problem sending the message with the link. Please try again or email contact@hecoanalytics.com if the issue persists.
                  </div>
                  <div className="savemodal-btn-container">
                  
                    <button className="button-close" onClick={handleCloseModal}>
                      Done
                    </button>
                  </div>
                </>
              )
        }
      />
    </>
  )
}

export default MessageResultModal